import { useEffect, useState } from 'react';

const LoadJsonFromTxt = () => {
  const [data, setData] = useState(null);
  //const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the JSON data from the .txt file
    fetch('/publicCardsData.txt') // Ensure the file is in the public folder
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text(); // Read the file as plain text
      })
      .then(text => {
        setData(JSON.parse(text)); // Parse the JSON and update state
      })
      .catch(err => {
        //setError(err.message);
      });
  }, []); // Empty dependency array ensures this runs once on mount

  return data;
};

export default LoadJsonFromTxt;
